(() => {
  if (window.AWLot4MonAtelierGuard?.version) return;

  const POSTPURCHASE_ENTRIES = new Set([
    'thank_you',
    'order_status',
    'order_action',
    'order_index',
    'customer_profile',
    'account_menu',
    'login_return'
  ]);

  const track = (name, payload = {}) => {
    try { window.AWAnalytics?.track?.(name, payload); } catch (_) {}
  };

  const isPostPurchaseEntry = () => {
    try {
      return POSTPURCHASE_ENTRIES.has(new URLSearchParams(window.location.search).get('aw_entry') || '');
    } catch (_) {
      return false;
    }
  };

  const moveOrderBridge = () => {
    const root = document.querySelector('[data-aw-atelier]');
    if (!root) return false;
    let moved = false;
    document.querySelectorAll('[id^="AWOrderAttributionBridge-"]').forEach((bridge) => {
      const source = bridge.querySelector('[data-aw-shopify-orders]');
      if (source) {
        root.prepend(source);
        moved = true;
      }
      bridge.remove();
    });
    return moved;
  };

  const cleanOrderSources = () => {
    const root = document.querySelector('[data-aw-atelier]');
    if (!root) return null;
    const sources = [...root.querySelectorAll('[data-aw-shopify-orders]')];
    if (!sources.length) return null;
    const enriched = sources.find((source) => source.dataset.awOrderSource === 'enriched')
      || sources[0];
    sources.forEach((source) => { if (source !== enriched) source.remove(); });
    root.dataset.awOrderSource = enriched.dataset.awOrderSource || 'legacy';
    return enriched;
  };

  const improveCopy = (root) => {
    if (!root) return;
    root.querySelectorAll('dt,th').forEach((node) => {
      const label = node.textContent.trim();
      if (label === 'Marge' || label === 'Écart budget') node.textContent = 'Écart au budget';
    });

    const historyStat = [...root.querySelectorAll('.aw-atelier__stats small')]
      .find((node) => node.textContent.trim() === 'ajouts au panier suivis');
    if (historyStat) historyStat.textContent = 'commandes et ajouts AW suivis';

    const panel = root.querySelector('[data-aw-atelier-panel="recommendations"]');
    if (!panel) return;
    const postPurchaseEntry = isPostPurchaseEntry();
    const heading = panel.querySelector('.aw-atelier__panel-heading h2');
    if (heading?.textContent.trim() === 'Prochaines améliorations recommandées') {
      heading.textContent = 'Suggestions après achat — à vérifier';
    }
    const badge = panel.querySelector('.aw-atelier__panel-heading > span');
    const badgeCopy = postPurchaseEntry
      ? 'Commande Shopify → Mon Atelier'
      : 'Suggestions par plateforme — à vérifier';
    if (badge && badge.textContent.trim() !== badgeCopy) badge.textContent = badgeCopy;

    const emptyTitle = panel.querySelector('[data-aw-atelier-recommendations-empty] h3');
    if (emptyTitle?.textContent.trim() === 'Aucune recommandation pour le moment') {
      emptyTitle.textContent = 'Aucune suggestion pour le moment';
    }
    const emptyText = panel.querySelector('[data-aw-atelier-recommendations-empty] p');
    if (emptyText?.textContent.includes('conseils d’amélioration personnalisés')) {
      emptyText.textContent = 'Ajoutez une configuration au panier pour afficher des suggestions contextuelles basées sur les données AW disponibles.';
    }

    let note = panel.querySelector('[data-aw-lot4-recommendation-note]');
    if (!note) {
      note = document.createElement('p');
      note.dataset.awLot4RecommendationNote = 'true';
      note.className = 'aw-atelier__help';
      panel.querySelector('.aw-atelier__panel-heading')?.after(note);
    }
    const noteCopy = postPurchaseEntry
      ? 'Vous arrivez depuis une commande ou votre compte client. Mon Atelier privilégie d’abord les produits réellement achetés et les relations AW documentées ; les suggestions de catalogue restent secondaires.'
      : 'Ces cartes sont des suggestions de catalogue basées d’abord sur la plateforme. Une correspondance de plateforme ne confirme pas à elle seule la compatibilité mécanique, électrique ou dimensionnelle : vérifiez le fabricant, le type, la version et la fiche produit.';
    if (note && note.textContent !== noteCopy) note.textContent = noteCopy;
  };

  const run = () => {
    moveOrderBridge();
    const source = cleanOrderSources();
    const root = document.querySelector('[data-aw-atelier]');
    if (!root) return;
    improveCopy(root);
    if (root.dataset.awLot4SourceTracked !== 'true') {
      root.dataset.awLot4SourceTracked = 'true';
      track('mon_atelier_order_source_ready', {
        source: source?.dataset.awOrderSource || root.dataset.awOrderSource || 'legacy',
        order_count: source?.querySelectorAll('[data-aw-shopify-order]').length || 0
      });
    }
    if (root.dataset.awLot4Observed === 'true') return;
    root.dataset.awLot4Observed = 'true';
    const observer = new MutationObserver(() => improveCopy(root));
    observer.observe(root, { childList: true, subtree: true, characterData: true });
  };

  window.AWLot4MonAtelierGuard = { version: '1.3.1', run };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
  else run();
  document.addEventListener('shopify:section:load', run);
})();